import { createContext, useContext, useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getTest, deleteTest } from "../../api/testimonial";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { useNavigate } from "react-router-dom";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const [page, setPage] = useState(1);
  const toaster = useToaster();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState("home");

  const getBlogsQuery = useQuery({
    queryKey: ["blogs", page, activePage],
    queryFn: () => getTest({ page, page_url: activePage }),
    keepPreviousData: true,
  });

  const deleteBlogQuery = useMutation({ mutationFn: deleteTest });

  const handleWorkDelete = (item) => {
    deleteBlogQuery.mutate(item.id, {
      onSuccess: () => {
        queryClient.invalidateQueries(["blogs"]);
        toaster.success(Const.MESSAGES.SUCCESS, "Testimonial is deleted successfully.");
      },
    });
  };

  const handleAddBlogClick = () => {
    navigate(`/testimonials/add?page=${activePage}`);
  };

  const handleEditClick = (item) => {
    navigate(`/testimonials/add?id=${item.id}&page=${activePage}`);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <PageContext.Provider
      value={{
        getBlogsQuery,
        handleWorkDelete,
        handleAddBlogClick,
        handleEditClick,
        handlePageChange,
        currentPage: page,
        activePage,
        setActivePage,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const useBlogsProvider = () => {
  return useContext(PageContext);
};
